<template>
  <div>
    <div
      ref="replyContainer"
      class="quick-replies scroll-area">
      <div
        class="reply-item new-quick-reply"
        @click="openCreateReplyModal">
        <p>Create New Quick Reply</p>
      </div>
      <div
        v-for="reply in quickReplies"
        :key="reply.id"
        :ref="`reply-${reply.id}`"
        class="reply-item">
        <p
          :class="{active: isActiveReply(reply)}"
          class="message"
          @click="selectReply(reply)">
          <span class="keyword">/{{ reply.keyword }}</span>
          <MessageContent :content="reply.text"/>
        </p>
        <div class="action-buttons">
          <span
            class="action-button edit"
            @click="openUpdateReplyModal(reply)">
            <icon name="pencil-alt"/>
          </span>
          <span
            class="action-button delete"
            @click="showDeleteReplyModal(reply.id)">
            <icon name="times"/>
          </span>
        </div>
      </div>
    </div>
    <QuickReplyModal
      ref="quickReplyModal"
      @replySaved="loadQuickReplies"/>
    <DeleteQuickReplyModal
      ref="deleteReplyModal"
      @deleted="loadQuickReplies"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import QuickReplyModal from '../modals/QuickReplyModal';
import MessageContent from '../../../common/MessageContent';
import DeleteQuickReplyModal from '../modals/DeleteQuickReplyModal';

export default {
  name: 'QuickReplies',
  components: {
    QuickReplyModal,
    DeleteQuickReplyModal,
    MessageContent,
  },
  props: {
    keyword: {
      type: String,
      default: '',
    },
    trackKeys: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default() {
        return {
          name: '',
        };
      },
    },
  },
  data() {
    return {
      quickReplies: [],
      activeReply: {},
    };
  },
  computed: {
    ...mapGetters({
      quickRepliesLoaded: 'chat/quickRepliesLoaded',
      quickReplyList: 'chat/quickReplyList',
      merchantName: 'merchant/merchantName',
      agentName: 'user/name',
      agentFirstName: 'user/firstName',
    }),
    messageTagValues() {
      return [
        {
          keyword: '{{business_name}}',
          value: this.merchantName,
        },
        {
          keyword: '{{contact_name}}',
          value: this.contact.name,
        },
        {
          keyword: '{{agent_first_name}}',
          value: this.agentFirstName,
        },
        {
          keyword: '{{agent_name}}',
          value: this.agentName,
        },
      ];
    },
  },
  watch: {
    quickRepliesLoaded(loaded) {
      if (loaded) {
        this.quickReplies = this.quickReplyList;
        this.activeReply = this.quickReplyList[0];
      }
    },
    keyword(keyword) {
      this.quickReplies = this.$lodash.filter(this.quickReplyList, reply => (reply.keyword.indexOf(keyword) === 0));
      this.activeReply = this.quickReplies[0] || {};
    },
  },
  mounted() {
    this.loadQuickReplies();
    document.onkeydown = (e) => {
      if (this.trackKeys) {
        const event = e || window.event;
        switch (event.which || event.keyCode) {
          case 13:
            this.selectReply(this.activeReply);
            break;
          case 38:
            this.shiftActiveReply('up');
            break;
          case 40:
            this.shiftActiveReply('down');
            break;
          default:
            break;
        }
      }
    };
  },
  methods: {
    ...mapActions({
      fetchQuickReplies: 'chat/fetchQuickReplies',
    }),
    isActiveReply(reply) {
      return this.activeReply && (reply.id === this.activeReply.id);
    },
    loadQuickReplies() {
      this.fetchQuickReplies(this.$route.params.merchant_id);
    },
    openCreateReplyModal() {
      this.$refs.quickReplyModal.show();
    },
    openUpdateReplyModal(reply) {
      this.$refs.quickReplyModal.setReply(reply);
      this.$refs.quickReplyModal.show();
    },
    shiftActiveReply(direction) {
      const currentIndex = this.$lodash.findIndex(this.quickReplies, reply => reply.id === this.activeReply.id);
      let nextIndex = 0;

      if (direction === 'up') {
        nextIndex = (currentIndex === 0) ? this.quickReplies.length - 1 : currentIndex - 1;
      } else {
        nextIndex = (currentIndex === (this.quickReplies.length - 1)) ? 0 : currentIndex + 1;
      }

      this.activeReply = this.quickReplies[nextIndex];
      this.adjustScrollPosition();
    },
    adjustScrollPosition() {
      const itemScrollOffset = this.$refs[`reply-${this.activeReply.id}`][0].offsetTop;
      const replyContainerScrollPosition = this.$refs.replyContainer.scrollTop;

      if ((itemScrollOffset - replyContainerScrollPosition >= 190) ||
          (itemScrollOffset - replyContainerScrollPosition < 0)) {
        this.$refs.replyContainer.scrollTop = itemScrollOffset;
      }
    },
    selectReply(reply) {
      if (this.$lodash.isEmpty(reply)) {
        return;
      }
      this.$emit('replySelected', this.changeTagsToValues(reply.text));
    },
    changeTagsToValues(reply) {
      this.messageTagValues.forEach((tagReplacement) => {
        reply = reply.replace(new RegExp(tagReplacement.keyword, 'g'), tagReplacement.value);
      });

      return reply;
    },
    showDeleteReplyModal(replyId) {
      this.$refs.deleteReplyModal.replyToDelete(replyId);
      this.$refs.deleteReplyModal.show();
    },
  },
};
</script>
